import React from 'react';

const VedantaHighlightsColOne = () => {
  return (
    <div className="highlights-col">
      <h5>~80,000</h5>
      <p>
        People engaged creating <strong>9,62,824</strong> man-years of employment
      </p>

      <h5>INR 83,545 Crore</h5>
      <p>Revenue</p>

      <h5>INR 6,122 Crore</h5>
      <p>Net profit after tax before exceptional item</p>
    </div>
  );
};

export default VedantaHighlightsColOne;
